import { createNamespacedHelpers } from 'vuex'

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('user')
export const authComputed = {
    ...mapGetters(['loggedIn', 'user'])
}
